import { Card, Form, Input } from "antd";
import React, { useState } from "react";

import FormAction from "../../../../components/common/FormAction";

function OnlinePortalStatus({data}) {
  const [checked, setChecked] = useState(false);

  const onCancel = () => {
    setChecked(false);
  };
  return (
    <Card
      title="Online Portal Status"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Form.Item label="Portal Activated">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Last Activation Email Sent">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Auto Payments">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Auto Payments Total">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Transaction Fee">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Login Email">
            <Input disabled />
          </Form.Item>
          <p className="onclick-red-text" style={{ textAlign: "right" }}>
            Delete Login
          </p>
          <FormAction cancel={onCancel} />
        </Form>
      ) : (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
        >
          <Form.Item label="Portal Activated">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Last Activation Email Sent">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Auto Payments">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Auto Payments Total">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Transaction Fee">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Portal Payments">
            <p className="onclick-text">View Online Payments</p>
          </Form.Item>
          <Form.Item label="Two Factor Enabled">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Opt Tenant Out of Portal">
            <p>--</p>
          </Form.Item>
          <Form.Item label="Login Email">
            <p>--</p>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default OnlinePortalStatus;
